import React from 'react'
import { styled } from '@mui/material/styles'
import { ArticleFragment } from '@services/graphcms/client'
import { Tag } from './Tag'

const PREFIX = 'Tags'

const classes = {
  caption: `${PREFIX}-caption`,
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.caption}`]: {
    marginTop: theme.spacing(0.3),
  },
}))

type Props = {
  article: ArticleFragment
  textType: boolean
}

export const Tags = (props: Props) => (
  <Root className={classes.caption}>
    {props.article?.categories &&
      props.article?.categories.map((category, index: number) => (
        <Tag key={index} data={category} type="category" textType={props.textType} />
      ))}
    {props.article?.tags &&
      props.article?.tags.map((tag, index: number) => (
        <Tag key={index} data={tag} type="tag" textType={props.textType} />
      ))}
  </Root>
)
